<template>
  <fieldset class="mb-3" :disabled="bloqueado">
    <div
      class="card shadow-sm abas-formulario-card"
      :class="{ 'frame-bloqueado': bloqueado }"
      :style="cssVars"
    >
      <div
        class="card-header py-0 px-0 border-bottom-0 d-flex justify-content-between align-items-start"
        :class="{ 'cursor-pointer': colapsavel }"
        @click="onClickHeader"
      >
        <ul class="nav nav-tabs mb-0 px-3 pt-2 flex-grow-1" role="tablist">
          <li v-for="aba in abas" :key="aba.key" class="nav-item" role="presentation">
            <button
              class="nav-link"
              :class="{ active: modelValue === aba.key, disabled: aba.disabled }"
              :disabled="aba.disabled"
              @click="selecionar(aba)"
              type="button"
              role="tab"
            >
              <i v-if="aba.icon" :class="['bi', aba.icon, 'me-1']"></i>
              {{ aba.label }}
            </button>
          </li>
        </ul>
        <i
          v-if="colapsavel"
          class="bi fs-5 pt-2 pe-3 flex-shrink-0"
          :class="aberto ? 'bi-chevron-up' : 'bi-chevron-down'"
        ></i>
      </div>
      <div class="card-body" v-show="!colapsavel || aberto">
        <template v-for="aba in abas" :key="aba.key">
          <div v-show="modelValue === aba.key" role="tabpanel">
            <slot :name="`tab-${aba.key}`"></slot>
          </div>
        </template>
      </div>
    </div>
  </fieldset>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  // Chave da aba ativa (v-model)
  modelValue: { type: String, default: '' },
  // Lista de abas: [{ key, label, icon, disabled }]
  abas: { type: Array, default: () => [] },
  // Habilita o colapso do corpo das abas
  colapsavel: { type: Boolean, default: true },
  // Cor Bootstrap (info, success, primary, warning, danger, secondary)
  cor: { type: String, default: 'info' },
  // Aplica o estado de bloqueio (padrão "Salvar e Continuar")
  bloqueado: { type: Boolean, default: false },
  // Estado inicial do colapso
  inicialmenteAberto: { type: Boolean, default: true }
})

const emit = defineEmits(['update:modelValue'])

const aberto = ref(props.inicialmenteAberto)

const cssVars = computed(() => ({
  '--abas-cor': `var(--bs-${props.cor})`,
  '--abas-cor-rgb': `var(--bs-${props.cor}-rgb)`,
  '--abas-cor-emphasis': `var(--bs-${props.cor}-text-emphasis)`,
  '--abas-cor-subtle': `var(--bs-${props.cor}-subtle)`
}))

const selecionar = (aba) => {
  if (aba.disabled) return
  emit('update:modelValue', aba.key)
  if (props.colapsavel) aberto.value = true
}

const onClickHeader = (event) => {
  if (!props.colapsavel) return
  // Clique em uma aba expande (nunca colapsa)
  if (event.target.closest('.nav-item, .nav-link, button[role="tab"]')) {
    aberto.value = true
    return
  }
  aberto.value = !aberto.value
}
</script>

<style scoped>
.abas-formulario-card {
  border-color: var(--abas-cor-subtle);
}

.abas-formulario-card > .card-header {
  background-color: var(--abas-cor-subtle);
}

.nav-tabs {
  border-bottom: none;
}

.nav-tabs .nav-link {
  border: none;
  color: var(--bs-secondary-color);
  font-weight: 500;
  padding: 0.75rem 1rem;
  min-width: 130px;
  text-align: center;
  transition: all 0.2s ease;
}

.nav-tabs .nav-link:hover {
  color: var(--abas-cor-emphasis);
  background-color: rgba(var(--abas-cor-rgb), 0.05);
}

.nav-tabs .nav-link.active {
  color: var(--abas-cor-emphasis);
  background-color: transparent;
  border-bottom: 3px solid var(--abas-cor);
  font-weight: 600;
}

.nav-tabs .nav-link.disabled {
  color: var(--bs-secondary-color);
  opacity: 0.5;
  cursor: not-allowed;
}

.frame-bloqueado {
  opacity: 0.6;
}
</style>
